<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-05 09:24:51
 * @LastEditors: hexy
 * @LastEditTime: 2024-04-02 16:49:32
 * @Description: 配合比库-选择原物料
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\components\rawChoose.vue
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="isChooseRawDialog" width="960px" :close-on-click-modal="false" :append-to-body="true" :before-close="resetRawFromDate">
      <span slot="title" class="dialog-title">{{ rawDialogTitle }}</span>
      <div class="dialoginfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          原物料名称:
          <el-input v-model="tableParam.name" size="mini" style="width: 100px" placeholder="请输入" @keyup.enter.native="queryRaw()"></el-input>
          <span style="margin-left: 12px">规格:</span>
          <el-input v-model="tableParam.specification" size="mini" style="width: 100px" placeholder="请输入" @keyup.enter.native="queryRaw()"></el-input>
          <span style="margin-left: 12px">编号:</span>
          <el-input v-model="tableParam.barCode" size="mini" style="width: 100px" placeholder="请输入" @keyup.enter.native="queryRaw()"></el-input>
          <span style="margin-left: 12px">品牌:</span>
          <el-select v-model="tableParam.brandId"  size="mini" placeholder="请选择" style="width: 100px" filterable @change="queryRaw()">
            <el-option v-for="item in brandlist" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
          </el-select>
          <div style="position: absolute; right: 0; top: 0">
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="queryRaw()">搜索</el-button>
            <el-button size="mini" class="bottom_all but1" style="margin-left: 10px" @click="init()">重置</el-button>
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }"
          border
          stripe
          style="width: 100%"
          :data="tableData"
          :row-key="row => row.id"
          tooltip-effect="dark"
          @selection-change="handleSelection"
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column label="编号" align="center" prop="barCode" :min-width="100"></el-table-column>
          <el-table-column label="原物料名称" align="center" prop="name" :min-width="160"></el-table-column>
          <el-table-column label="规格" align="center" prop="specification" :min-width="140"></el-table-column>
          <el-table-column label="品牌" align="center" prop="brand" :min-width="140"></el-table-column>
          <el-table-column label="产地" align="center" prop="originPlace" :min-width="140"></el-table-column>
          <el-table-column label="生产厂家" align="center" prop="manufacturer" :min-width="140"></el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" layout="total, prev, pager, next, jumper" :total="total" @current-change="queryRaw()"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetRawFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveRawFromDate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryRaw } from "@/api/basicConfig/mixForm.js";
import { getDicType } from "@/api/common.js";
export default {
  data() {
    return {
      /*表格增删改查及下载接口*/
      options: [],
      /*表格数据*/
      rawDialogTitle: "选择原物料",
      tableParam: {
        page: 1,
        pageSize: 10,
        type: 1,
      },
      total: 0,
      tableData: [],
      selectRaw: [],
      planData: {},
      listData: {},
      index: "",
      brandlist: [],
    };
  },
  props: {
    isChooseRawDialog: {
      type: Boolean,
      default: false,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    isRawIndex: {
      type: Number,
      default: 0,
    },
    stationId: {
      type: String,
      default: "",
    },
  },
  watch: {
    // isRawIndex(val) {
    //   this.index=val
    //   console.log(555555)
    //   console.log(val)
    // },
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, name: "", specification: "", brandId: "",barCode:"", };
    getDicType({ code: "MATbrand" }).then(res => {
      this.brandlist = res.data.items;
    });
    this.queryRaw();
  },
  methods: {
    //选择
    handleSelection(val) {
      this.selectRaw = [];
      this.selectRaw = val;
      if (this.selectRaw?.length > 1) {
        this.$message.warning("只能选择一个");
        this.selectRaw = [];
      }
    },
    init() {
      this.tableParam = { page: 1, pageSize: 10, type: 1, name: "", specification: "", brandId: "",barCode:"" };
      this.queryRaw();
    },
    queryRaw() {
      queryRaw({ ...this.tableParam,companyId:this.stationId }).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
      });
    },
    //主页面添加事件
    async addClick() {
      await this.queryRaw();
      this.selectRaw = [];
    },

    resetRawFromDate() {
      this.init();
      this.$emit("update:isChooseRawDialog", false);
      this.$refs.multipleTable.clearSelection();
    },
    /*保存/修改弹窗*/
    saveRawFromDate() {
      this.selectRaw = this.selectRaw.map(item => ({
        name: item.name + "_" + item.specification + "_" + item.brand + "_" + item.originPlace + "_" + item.manufacturer,
        id: item.id,
        deviation: "",
        theoreValue: "",
        theoreValueTrueOut:"",
        rawFormCodeOut:"",
      }));
      this.init();
      this.$emit("selectRaw", this.selectRaw, this.isUpdate, this.isRawIndex);
      this.resetRawFromDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
</style>
